import React from 'react';

// Page header: title, optional subtitle, optional right-aligned actions.
//
// Previously this returned null unless `actions` were passed, which silently
// dropped the title. The redesign puts a title + subtitle at the top of every
// page, so it now renders whenever it has anything to show.
function PageHeader({ title, sub, actions }) {
  if (!title && !sub && !actions) return null;
  return (
    <div className="page-header">
      <div className="page-header-titles">
        {title && <div className="page-title">{title}</div>}
        {sub && <div className="page-subtitle">{sub}</div>}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;
